import React from 'react'
import { isDev } from 'config/api.config'
import { useEffect, useDispatch, useSelector, useOn } from 'hooks'
import { openModal } from 'store/reducers/modals/actions'
import { FLAG_SETTER_MODAL } from 'components/Modal/modalTypes'
import { modalsMap } from 'components/Modal'

const ModalsWrapper = () => {
  const modals = useSelector(s => s.modals)
  const isDeveloper = useSelector(s => /datingfactory\.com$/.test(s.myProfile.email))
  const dispatch = useDispatch()

  useOn('keydown', e => {
    if ((e.key == '/' && e.ctrlKey) || (e.key == '?' && !e.target?.nodeName?.match(/input|textarea/i))) {
      if (isDev || isDeveloper || localStorage.flagSetter) {
        e.preventDefault()
        dispatch(openModal(FLAG_SETTER_MODAL))
      }
    }
  })

  useEffect(() => {
    document.querySelector('html').classList[modals.length ? 'add' : 'remove']('modal-open')
  }, [modals])

  const modal = modals[0]
  const M = (modal && modalsMap[modal.modalId]) || modalsMap.default

  return modal ? <M data={modal.data} modalId={modal.modalId} /> : null
}

export default ModalsWrapper
